module.exports = "div#getintouch {\r\n    padding: 0px 0 !important;\r\n}\r\n.con{\r\n    margin-top: 193px;background-size: initial;padding: 52px;background-repeat: repeat;background-image: -webkit-gradient(linear, left top, right top, from(rgba(255,0,0,0)), to(#157fda));background-image: linear-gradient(to right, rgba(255,0,0,0), #157fda);\r\n}\r\n.footer-area {\r\n    background: #fff;\r\n    padding: 0px 0px !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/quicklinks/quicklinks.component.css
// module id = ./src/app/home/quicklinks/quicklinks.component.css
// module chunks = main